module.exports = __webpack_public_path__ + "static/media/mini-clouds-matt-wilson.d8d0740e.png";